import { render, staticRenderFns } from "./OrgChartDetails.vue?vue&type=template&id=6195509c&scoped=true"
import script from "./OrgChartDetails.vue?vue&type=script&lang=js"
export * from "./OrgChartDetails.vue?vue&type=script&lang=js"
import style0 from "./OrgChartDetails.vue?vue&type=style&index=0&id=6195509c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6195509c",
  null
  
)

export default component.exports